// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file unacast/boundaries/exportpb/v1/export.proto (package unacast.boundaries.exportpb.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum unacast.boundaries.exportpb.v1.ExportFormat
 */
export enum ExportFormat {
  /**
   * @generated from enum value: EXPORT_FORMAT_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXPORT_FORMAT_CSV = 1;
   */
  CSV = 1,

  /**
   * @generated from enum value: EXPORT_FORMAT_GEOJSON = 2;
   */
  GEOJSON = 2,
}
// Retrieve enum metadata with: proto3.getEnumType(ExportFormat)
proto3.util.setEnumType(ExportFormat, "unacast.boundaries.exportpb.v1.ExportFormat", [
  { no: 0, name: "EXPORT_FORMAT_UNSPECIFIED" },
  { no: 1, name: "EXPORT_FORMAT_CSV" },
  { no: 2, name: "EXPORT_FORMAT_GEOJSON" },
]);

/**
 * @generated from message unacast.boundaries.exportpb.v1.ExportSpec
 */
export class ExportSpec extends Message<ExportSpec> {
  /**
   * @generated from field: unacast.boundaries.exportpb.v1.ExportFormat format = 1;
   */
  format = ExportFormat.UNSPECIFIED;

  constructor(data?: PartialMessage<ExportSpec>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.exportpb.v1.ExportSpec";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "format", kind: "enum", T: proto3.getEnumType(ExportFormat) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ExportSpec {
    return new ExportSpec().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ExportSpec {
    return new ExportSpec().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ExportSpec {
    return new ExportSpec().fromJsonString(jsonString, options);
  }

  static equals(a: ExportSpec | PlainMessage<ExportSpec> | undefined, b: ExportSpec | PlainMessage<ExportSpec> | undefined): boolean {
    return proto3.util.equals(ExportSpec, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.exportpb.v1.Destination
 */
export class Destination extends Message<Destination> {
  /**
   * @generated from oneof unacast.boundaries.exportpb.v1.Destination.destination
   */
  destination: {
    /**
     * @generated from field: unacast.boundaries.exportpb.v1.Destination.GoogleCloudStorage google_cloud_storage = 1;
     */
    value: Destination_GoogleCloudStorage;
    case: "googleCloudStorage";
  } | {
    /**
     * @generated from field: unacast.boundaries.exportpb.v1.Destination.BigQuery big_query = 2;
     */
    value: Destination_BigQuery;
    case: "bigQuery";
  } | {
    /**
     * @generated from field: unacast.boundaries.exportpb.v1.Destination.Snowflake snowflake = 3;
     */
    value: Destination_Snowflake;
    case: "snowflake";
  } | { case: undefined; value?: undefined } = { case: undefined };

  constructor(data?: PartialMessage<Destination>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.exportpb.v1.Destination";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "google_cloud_storage", kind: "message", T: Destination_GoogleCloudStorage, oneof: "destination" },
    { no: 2, name: "big_query", kind: "message", T: Destination_BigQuery, oneof: "destination" },
    { no: 3, name: "snowflake", kind: "message", T: Destination_Snowflake, oneof: "destination" },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Destination {
    return new Destination().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Destination {
    return new Destination().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Destination {
    return new Destination().fromJsonString(jsonString, options);
  }

  static equals(a: Destination | PlainMessage<Destination> | undefined, b: Destination | PlainMessage<Destination> | undefined): boolean {
    return proto3.util.equals(Destination, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.exportpb.v1.Destination.GoogleCloudStorage
 */
export class Destination_GoogleCloudStorage extends Message<Destination_GoogleCloudStorage> {
  /**
   * @generated from field: string bucket = 1;
   */
  bucket = "";

  /**
   * @generated from field: string path = 2;
   */
  path = "";

  constructor(data?: PartialMessage<Destination_GoogleCloudStorage>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.exportpb.v1.Destination.GoogleCloudStorage";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "bucket", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Destination_GoogleCloudStorage {
    return new Destination_GoogleCloudStorage().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Destination_GoogleCloudStorage {
    return new Destination_GoogleCloudStorage().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Destination_GoogleCloudStorage {
    return new Destination_GoogleCloudStorage().fromJsonString(jsonString, options);
  }

  static equals(a: Destination_GoogleCloudStorage | PlainMessage<Destination_GoogleCloudStorage> | undefined, b: Destination_GoogleCloudStorage | PlainMessage<Destination_GoogleCloudStorage> | undefined): boolean {
    return proto3.util.equals(Destination_GoogleCloudStorage, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.exportpb.v1.Destination.BigQuery
 */
export class Destination_BigQuery extends Message<Destination_BigQuery> {
  /**
   * @generated from field: string project = 1;
   */
  project = "";

  /**
   * @generated from field: string dataset = 2;
   */
  dataset = "";

  /**
   * @generated from field: string table = 3;
   */
  table = "";

  constructor(data?: PartialMessage<Destination_BigQuery>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.exportpb.v1.Destination.BigQuery";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "project", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "dataset", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Destination_BigQuery {
    return new Destination_BigQuery().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Destination_BigQuery {
    return new Destination_BigQuery().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Destination_BigQuery {
    return new Destination_BigQuery().fromJsonString(jsonString, options);
  }

  static equals(a: Destination_BigQuery | PlainMessage<Destination_BigQuery> | undefined, b: Destination_BigQuery | PlainMessage<Destination_BigQuery> | undefined): boolean {
    return proto3.util.equals(Destination_BigQuery, a, b);
  }
}

/**
 * @generated from message unacast.boundaries.exportpb.v1.Destination.Snowflake
 */
export class Destination_Snowflake extends Message<Destination_Snowflake> {
  /**
   * @generated from field: string stage = 1;
   */
  stage = "";

  /**
   * @generated from field: string table = 2;
   */
  table = "";

  constructor(data?: PartialMessage<Destination_Snowflake>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "unacast.boundaries.exportpb.v1.Destination.Snowflake";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "stage", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Destination_Snowflake {
    return new Destination_Snowflake().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Destination_Snowflake {
    return new Destination_Snowflake().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Destination_Snowflake {
    return new Destination_Snowflake().fromJsonString(jsonString, options);
  }

  static equals(a: Destination_Snowflake | PlainMessage<Destination_Snowflake> | undefined, b: Destination_Snowflake | PlainMessage<Destination_Snowflake> | undefined): boolean {
    return proto3.util.equals(Destination_Snowflake, a, b);
  }
}

